/* eslint no-console:0 */

import { Application } from 'stimulus'

import InteractiveMapController from '../individually_loaded_controllers/interactive_map_controller'

window.Stimulus ||= Application.start()
window.Stimulus.register('interactive-map', InteractiveMapController)
